"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const MediaWrapper_1 = tslib_1.__importDefault(require("../../../ui-lib/MediaWrapper"));
const ErrorBoundary_1 = require("../../ErrorBoundary");
const ModularMediaContainer = (0, mobx_react_lite_1.observer)(({ children, classes, ...props }) => {
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext) != null
        ? (0, react_1.useContext)(context_1.EncoderUiContext)
        : (0, react_1.useContext)(context_1.PlayerUiContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, "<MediaContainer/>");
    const mediaWrapperComponent = (react_1.default.createElement(MediaWrapper_1.default, { ref: ctx.videoWrapperElement, classes: classes, isFullscreen: ctx.isFullscreen, ...props }, children));
    // return !uiState.launchNewWindow
    //   ? mediaWrapperComponent
    //   : createPortal(mediaWrapperComponent, uiState.newWindowElement);
    return mediaWrapperComponent;
});
// eslint-disable-next-line react/function-component-definition
const MediaContainerWithErrorBoundary = ({ classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(MediaWrapper_1.default, { classes: classes, ...props }) },
        react_1.default.createElement(ModularMediaContainer, { classes: classes, ...props })));
};
exports.default = MediaContainerWithErrorBoundary;
//# sourceMappingURL=MediaContainer.js.map